module.exports = __webpack_public_path__ + "img/coffin-cross.dbd305cc.svg";